var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tagsDisplayer"},_vm._l((_vm.classifiedTags),function(cTags,name,i){return _c('div',{key:i,staticClass:"tagSection"},[_c('div',{staticClass:"sectionName"},[_vm._v(_vm._s(name))]),_c('Tags',{attrs:{"tags":cTags},on:{"tagClicked":_vm.tagClicked}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }